import React from "react";
import { useHistory } from "react-router-dom";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import Button from "../../shared/button";
import Expired from "./images/expired-icon.png";
import styles from "./styles.css";

const TradeInValuationExpired = () => {

    const history = useHistory();

    const handleOnApplyAgain = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TRADE_IN_TOP_FUNNEL_TRADE_IN, {eventLabel: "offer_expired_apply_again"});
        history.push("/trade-in/");
    };

    return (
        <div styleName={"styles.wrapper"}>
            <div styleName={"styles.outer"}>
                <img src={Expired} />
                <h1 styleName="styles.heading">Your car’s valuation has expired</h1>
                <p styleName={"styles.description"}>Apply again to see your car’s valuation and net payable amount on every car</p>
                <span styleName={"styles.buttonWrapper"}>
                    <Button text="APPLY AGAIN" onClick={handleOnApplyAgain} />
                </span>
            </div>
        </div>
    );
};

export default TradeInValuationExpired;
